export function jsonOrTextFromResponse(response) {
    const contentType = response.headers.get('Content-type');
    return contentType && contentType.includes('application/json') ? response.json() : response.text();
}

export function ajustarEspaciadoMain() {
    const main = document.querySelector('main');
    const header = document.querySelector('.header');

    if(window.getComputedStyle(header).position === 'fixed'){
        main.style.marginTop = (header.offsetHeight - 3) + 'px';
    }else{
        main.removeAttribute('style');
    }
}

export function eliminarErroresSpan() {
    const spanAnterior = document.querySelectorAll(`.alerta__error`);

    if(spanAnterior){
        spanAnterior.forEach(span =>{
            span.remove();
        })
    }
}

export function renderAlertas(alertas, {ubicacion='arriba'}) {
    eliminarErroresSpan();

    for(const key in alertas.error){
        // const campo = document.querySelector(`.${classMain}__campo-${key}`);
        const campo = document.querySelector(`[data-campo="${key}"]`);
        
        if(campo){

            const spanAlerta = document.createElement('SPAN');
            spanAlerta.classList.add(`alerta__error`)
            spanAlerta.textContent = `*${alertas.error[key]}`;
            if(ubicacion === 'arriba'){
                campo.prepend(spanAlerta);
            }else if(ubicacion === 'abajo'){
                campo.appendChild(spanAlerta);
            }
        }
    }
}

export function mostrarSpinner() {
    document.querySelector(".bubble").classList.add("bubble--show");
    
}
export function ocultarSpinner() {
    document.querySelector(".bubble").classList.remove("bubble--show");
}